export default __webpack_public_path__ + "static/media/balanca-prix.808ecc77.png";